 var console = window.console;

class Header extends HTMLElement {
  constructor() {
    super();
    
    this.mainNav = this.querySelector('.js-nav')
    this.mobMenuTriggers = this.querySelectorAll('.js-mob-menu-trigger')
    this.megaMenuTriggers = this.querySelectorAll('.js-mega-menu-trigger')
    this.goBackTrigger = this.querySelectorAll('.js-go-back-trigger')
    this.body = document.body
    this.accordionsTriggers = this.querySelectorAll('.js-acc-trigger')

    if (window.innerWidth < 991) {
      this.mobMenu();
      this.mobAccordion();
    }

    this.onScroll();
  }

  removeAllIsActive(items) {
    items.forEach(item => {
      if (item.nextElementSibling) {
        if (item.nextElementSibling.classList.contains('is-open')) {
          item.nextElementSibling.classList.remove('is-open')
        }
      }
    });
  }

  mobMenu() {
    this.mobMenuTriggers.forEach(mainTrigger => {
      mainTrigger.addEventListener('click', (e) => {
        if (!this.mainNav.classList.contains('is-open')) {
          this.mainNav.classList.add('is-open')
          document.body.classList.add('overflow-hidden')
        } else {
          this.mainNav.classList.remove('is-open')
          this.removeAllIsActive(this.megaMenuTriggers)
          document.body.classList.remove('overflow-hidden')
        
        }
      })
    })

    this.megaMenuTriggers.forEach(megaMenuTrigger => {
      megaMenuTrigger.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (e.target.nextElementSibling !== null && !e.target.nextElementSibling.classList.contains('is-open')) {
          e.target.nextElementSibling.classList.add('is-open')
        }
      })
    })

    this.goBackTrigger.forEach(el => {
      el.addEventListener('click', (e) => {
        if (el.parentElement.parentElement.classList.contains('is-open')) {
          el.parentElement.parentElement.classList.remove('is-open')
        }
      })
    })
  }

  onScroll() {
    const height = this.clientHeight
    let oldValue = window.scrollY

    window.addEventListener('scroll', () => {
      if (window.scrollY > height) {
        this.classList.add('is-active')
        this.body.classList.add('scroll-down')

        if (window.scrollY > oldValue) {
          this.classList.add('is-active')
          this.body.classList.add('scroll-down')
        } 
        oldValue = window.scrollY
      } else if (window.scrollY < 500) {
        this.classList.remove('is-active')
        this.body.classList.remove('scroll-down')
      }
    })
  }

  mobAccordion () {
    this.accordionsTriggers.forEach(accWrapper => {
    const trigger = accWrapper.querySelector('span')

      trigger.addEventListener('click', (e) => {
        if (!e.target.classList.contains('acc-is-open')) {
          this.accordionsTriggers.forEach(item => {
            const trigger = item.querySelector('span')
            trigger.classList.remove('acc-is-open')
            trigger.nextElementSibling.style.height = null
          })
          e.target.classList.add('acc-is-open')
          e.target.nextElementSibling.style.height = e.target.nextElementSibling.scrollHeight + 'px'
        } else {
          e.target.classList.remove('acc-is-open')
          e.target.nextElementSibling.style.height = null
        }
      })
    })
  }
}

customElements.define('btt-header', Header)
